import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { switchMap, takeUntil, } from 'rxjs/operators';
import { PasswordValidationResponse, PasswordValidationPayload } from '@core/models/password.model';


@Injectable({
    providedIn: 'root'
})
export class PasswordValidationService {
    /**
     * This service validates password string strength for three actions: 
     *      - reset password 
     *      - confirm user
     *      - create new account
     * no token or hash required
     * /web/login/passwords/validity (working)
        body → {"password":"plain-password"} , optional when no eamil {"checksum": cheksum-number}
        url query param: ?email=pain-text-email
        response: {
        "level": (int) 0/1/2, //0 --> weak, 1 --> medium, 2 --> strong
        "valid": (bool) false/true
        }
     */
	  private readonly BASE_URL = "/web/login/passwords";
    private readonly RECOVERY_BASE_URL = "/web/login/passwords/recovery/";

    private cancelValidityRequest$: Subject<void> = new Subject<void>();

    constructor(public http: HttpClient) {}
    /**
     * 
     * @param pass plain-password-string
     * @param token the token for password recovery request (optional)
     * @param email the user email given for some of the validation cases (optional)
     * @returns PasswordValidationResponse: {
        "level": (int) 0/1/2, //0 --> weak, 1 --> medium, 2 --> strong
        "valid": (bool) false/true
        }
     */

    checkPasswordValidity(pass: string, token?: string, email?: string): Observable<PasswordValidationResponse> {
        let payload: PasswordValidationPayload;
        payload = { password: pass };
        // Emit to cancel any ongoing request
        this.cancelValidityRequest$.next();
        let url = this.BASE_URL+"/validity";
        if(token && token != ''){
          url = `${this.RECOVERY_BASE_URL}${token}/validity`;
        }
        if(email && email != ''){
          // Append email as a URL parameter if provided
          url += `?email=${email}`;
        }
        return this.http.post<PasswordValidationResponse>(url, payload).pipe(
            switchMap((response:PasswordValidationResponse) => {
              // Process your response here
              return this.processResponse(response);
            }),
            takeUntil(this.cancelValidityRequest$) // Cancel the request if cancelValidityRequest$ emits
          );
    }

    private processResponse(response: PasswordValidationResponse): Observable<PasswordValidationResponse> {
        // Your processing logic here
        return of(response);
      }
    

    // Call this method when you want to cancel ongoing requests explicitly
    cancelRequests(): void {
        this.cancelValidityRequest$.next();
    }


}